import React from 'react';
import { colors } from '../../config/constants';

interface InputProps {
  label?: string;
  placeholder?: string;
  value?: string | number;
  type: string;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  disabled?: boolean;
  handleEnterKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  width?: string;
  isShowPassword?: boolean;
  className?: string; 
}

const Input = (props: InputProps) => {
  const {
    name,
    label,
    placeholder,
    value,
    type,
    onChange,
    error,
    disabled,
    handleEnterKeyPress,
    isShowPassword = true,
    className,
  } = props;
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className="my-1">
      <div
        className={`${colors.primaryText} ml-2 mb-1 text-sm font-semibold`}
        data-testid="label"
      >
        {label}
      </div>
      <div className="relative lg:w-[270px] xl:w-[310px]">
        <input
          data-testid="input"
          type={showPassword ? 'text' : type}
          name={name}
          className={`w-full lg:w-[250px] xl:w-[300px] h-7 outline-none pl-2 text-sm border-b-2 focus:border-[#0369a1] pr-8 ${
            error === undefined ? '' : 'border-[red]'
          } placeholder-[#808080] ${className ? className : ''}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete="off"
          disabled={disabled}
          onKeyDown={handleEnterKeyPress}
          title={showPassword ? 'Hide password' : 'Show password'}
        />
        {type === 'password' && isShowPassword && (
          <div
            onClick={() => setShowPassword(!showPassword)}
            className="absolute md:right-2 lg:right-4 top-1/2 -translate-y-1/2 text-slate-500 focus:outline-none p-0"
          >
            <i
              className={`fa-solid ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
            ></i>
          </div>
        )}
      </div>
      <div className="text-sm text-[red] ml-2 mt-1" data-testid="error">
        {error}
      </div>
    </div>
  );
};

export default Input;
